import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Tournament } from '../../types/MTT';
import { formatMTTournamentAttr } from '../../utils';

const useFormattedBuyIn = (tournament: Tournament) => {
  const locale = useSelector(select.locale.getIntlLocale);
  const timeZoneName = useSelector(select.timeZone.getTimeZoneName);

  const { formattedBuyIn } = formatMTTournamentAttr(
    tournament,
    locale,
    tournament.isPlayMoney,
    timeZoneName
  );

  return formattedBuyIn;
};

export default useFormattedBuyIn;
